import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function Conclusion() {
  // const { lightColor, darkColor, primaryColor } = useContext(StoryContext);
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles(() => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >

        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            What does the data say?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                {/* <Typography variant="h5" gutterBottom>Has COVID-19 affected access to child care?</Typography> */}
                <Typography variant="body1">
                  There have been <b>decreases</b> in the supply of child care across the state.
                  This is especially problematic in neighborhoods with already marginalized populations who are being most impacted by this pandemic.
                  There has also been a <b>decline</b> in the number of <b>high-quality</b> providers as a result of COVID-19.
                </Typography>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Conclusion;
